/* Product page: bundle sizes (bottle + its Case bundle), store picker, scroll story. */
(() => {
  const { $, $$, money, store } = window.LLu;
  const pk = $('#pk'); if (!pk) return;
  const root = document.documentElement;
  root.classList.add('hdx-smart');
  const W = pk.dataset.word || 'bottle', handle = pk.dataset.handle;
  const box = $('#pdOffer');
  const OFF = JSON.parse(box.dataset.offers || '[]'); // [{ n, v, a, total, each, full }]
  const label = (n) => (n === 1 ? 'Single' : `${n} or more`); // tiers are minimums: 7 bottles get the 6 price
  const CHECK = '<svg viewBox="0 0 16 16"><path d="M4 8.4 6.8 11 12 5.4" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const pct = (o) => Math.round((1 - o.total / o.full) * 100);
  const best = OFF.reduce((k, o, i) => (o.each < OFF[k].each ? i : k), 0);

  // size list (dropdown)
  const tiersEl = $('.pd-tiers', box);
  if (tiersEl) tiersEl.innerHTML = OFF.map((o, k) => `<label class="pd-tier"><input type="radio" name="tier" value="${k}"${o.a ? '' : ' disabled'}><span class="pd-mark">${CHECK}</span><span class="pd-tl">${label(o.n)}</span>${pct(o) > 0 ? `<span class="pd-off">−${pct(o)}%</span>` : ''}<span class="pd-tr"><b data-each>${money(o.each)}</b> each</span>${k === best && k > 0 ? '<span class="pd-tag">Best value</span>' : ''}</label>`).join('');

  // the tier a quantity reaches: highest size <= qty (the "Buy more, save more" discount does the same in the cart)
  const tierFor = (n) => OFF.reduce((k, o, i) => (o.a && o.n <= n ? i : k), 0);
  // ?qty=12 opens on that quantity: shopping ads land on the exact offer they show
  const qn = Math.min(99, Math.max(1, Number(new URLSearchParams(location.search).get('qty')) || 1));
  const S = { t: tierFor(qn), n: qn }; // n = bottles (quantity stepper)
  if (OFF.length < 2) { $('.pd-pick', box)?.remove(); $('.pd-lbl', box)?.remove(); }
  const set = (sel, v) => $$(sel).forEach((e) => (e.textContent = v));

  function sync() {
    const o = OFF[S.t], one = o.n === 1;
    $$('.pd-tier', box).forEach((el, k) => { el.classList.toggle('on', k === S.t); $('input', el).checked = k === S.t; });
    set('[data-cur]', label(o.n)); set('[data-cureach]', money(o.each));
    const total = Math.round(o.each * S.n);
    // closed dropdown mirrors the open rows: a "buy more" cue on one bottle, the tier's tags + saving on a bundle
    const pick = $('[data-picksave]');
    if (pick) pick.innerHTML = one
      ? (OFF.length > 1 ? `<span class="pd-cue">Buy more, save up to ${Math.max(...OFF.map(pct))}%</span>` : '')
      : `${S.t === best ? '<span class="pd-tag">Best value</span>' : ''}<span class="pd-cue">Save ${money(OFF[0].each * S.n - total)}</span><span class="pd-corner">−${pct(o)}%</span>`;
    set('[data-one]', money(total));
    $('#pdQty').value = S.n;
    // headline: the per-bottle price the current quantity gets, with every tier listed under it
    set('[data-h-each]', money(o.each));
    const eachWord = $('.ph-big span'); if (eachWord) eachWord.style.display = one ? 'none' : ''; // a single price stands alone
    set('[data-h-was]', one ? (document.querySelector('[data-h-was]')?.dataset.sale || '') : money(OFF[0].each)); // the single price, struck out, beside the bundle price
    const badge = $('[data-h-badge]'); if (badge) { badge.hidden = one; badge.textContent = one ? '' : `${o.n}+ price · Save ${pct(o)}%`; }
    // the line under the price: tap a tier to jump the quantity to it
    const more = $('[data-h-more]'), go = (k, t) => `<button type="button" data-tk="${k}">${t}</button>`;
    const tiers = OFF.slice(1), solo = tiers.length === 1;
    if (more) more.innerHTML = one
      ? (tiers.length ? `<span class="phm-l">Buy more, save more:</span> ${tiers.map((x) => `<span class="phm-o"><b>${money(x.each)}</b> each ${solo ? 'when you buy' : 'for'} ${go(OFF.indexOf(x), `${x.n}+`)}</span>`).join('')}` : '')
      : `<span class="phm-o phm-save"><b>You save ${money(OFF[0].each * S.n - total)}</b> on ${S.n}</span>`;
    const buy = $('#buyMain'); buy.disabled = !o.a; buy.querySelector('span').textContent = o.a ? 'Add to cart' : 'Sold out';
    $('#pdFree').innerHTML = window.LL.rw$('<b>Spend [over] in 60 days</b>, get [amt] back', 0);
  }
  const more = (on) => { $$('[data-more]', box).forEach((b) => b.setAttribute('aria-expanded', String(on))); window.LLu.swing(box, (v) => box.classList.toggle('more', v), on); };
  $$('[data-more]', box).forEach((b) => b.addEventListener('click', () => more(!box.classList.contains('more'))));
  document.addEventListener('click', (e) => { if (box.classList.contains('more') && !e.target.closest('.pd-pick,.pd-tiers')) more(false); });
  box.addEventListener('change', (e) => {
    if (e.target.name !== 'tier') return;
    S.t = Number(e.target.value); S.n = OFF[S.t].n; sync(); more(false);
  });
  const setN = (n) => { S.n = Math.min(99, Math.max(1, Math.round(n) || 1)); S.t = tierFor(S.n); sync(); };
  $('[data-h-more]')?.addEventListener('click', (e) => { const b = e.target.closest('[data-tk]'); if (b) { S.t = Number(b.dataset.tk); S.n = OFF[S.t].n; sync(); } });
  $$('[data-qd]', box).forEach((b) => b.addEventListener('click', () => setN(S.n + Number(b.dataset.qd))));
  $('#pdQty').addEventListener('change', (e) => setN(Number(e.target.value)));

  // Buy once: always the bottle x quantity; the "Buy more, save more" automatic discount (ll-functions bundle-tiers)
  // gives 6+/12+ the tier price at the cart. A single bottle also gets the buy-more pop-up.
  $('#buyMain').addEventListener('click', () => {
    const o = OFF[S.t];
    const img = $('.pk-stage > img');
    const upsell = o.n === 1 && S.n === 1 ? { t: $('.pk-name').textContent, img: img ? img.src : '', p: o.total, v: o.v, w: W, cases: OFF.slice(1).map((x) => ({ n: x.n, v: x.v, p: x.total, a: x.a })) } : null;
    window.LLcart.add([{ id: OFF[0].v, quantity: S.n }], { upsell });
  });
  sync();

  // Click and collect: store dropdown + the shared store drawer (assets/ll-store-drawer.js; display only: pickup is chosen at Shopify checkout)
  const ship = $('[data-ship]'), sd = document.getElementById('pkDr') && document.getElementById('pkDr').__sd;
  if (ship && sd) {
    const pop = $('[data-ship-list]', ship), pb = $('[data-ship-pop]', ship), S = sd.stores;
    const pickStore = (n) => {
      let i = S.findIndex((x) => x.n === n && x.c !== 'no');
      if (i < 0) i = S.findIndex((x) => x.c !== 'no');
      if (i < 0) i = 0;
      const d = S[i];
      $$('[data-sname]').forEach((x) => (x.textContent = d.n));
      $$('[data-sstat]').forEach((x) => (x.textContent = d.s));
      $$('[data-sdot]').forEach((x) => (x.className = `pk-live ${d.c}`));
      $$('[data-st]').forEach((x) => x.classList.toggle('on', +x.dataset.i === i));
      sd.show(i);
    };
    const showPop = (on) => { if (pop) { pop.hidden = !on; pb.setAttribute('aria-expanded', on); } };
    sd.onpick = (i) => { pickStore(S[i].n); store.set('ll_pickup', S[i].n); };
    pickStore(store.get('ll_pickup', ''));
    document.addEventListener('click', (e) => {
      const r = e.target.closest('[data-st]');
      if (r) { pickStore(r.dataset.n); store.set('ll_pickup', r.dataset.n); showPop(false); return; }
      if (e.target.closest('[data-ship-pop]')) { showPop(pop.hidden); return; }
      if (pop && !e.target.closest('[data-ship-list]')) showPop(false);
      const o = e.target.closest('[data-ship-open]');
      if (o) sd.open(o, { hours: true });
    });
    addEventListener('keydown', (e) => { if (e.key === 'Escape') showPop(false); });
  }

  // store picker (display only: the pickup store is confirmed at Shopify checkout)
  const sheet = $('#pkStores');
  if (sheet) {
    const show = (on) => (sheet.hidden = !on);
    $$('[data-storeopen]').forEach((b) => b.addEventListener('click', () => show(true)));
    sheet.addEventListener('click', (e) => { if (e.target === sheet || e.target.closest('[data-storeclose]')) show(false); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape') show(false); });
    const pick = (id) => {
      const inp = $(`input[value="${CSS.escape(String(id))}"]`, sheet); if (!inp || inp.disabled) return;
      inp.checked = true; set('[data-storename]', inp.dataset.name); set('[data-storeready]', inp.dataset.ready);
    };
    pick(store.get('ll_store', ''));
    sheet.addEventListener('change', (e) => { pick(e.target.value); store.set('ll_store', e.target.value); setTimeout(() => show(false), 180); });
  }

  // smart header + story progress (--sp 0..1; not --p, which the review stars register as a percentage)
  const story = $('#story'), arts = $$('.pk-ch article', story);
  let last = scrollY, ticking = false;
  // --sp glides toward the scroll position (ease-out, ~180ms), so a mouse wheel's jumps become one smooth motion
  let spTarget = 0, spNow = 0, spT = 0, gliding = false;
  const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function glide(t) {
    const k = calm ? 1 : 1 - Math.exp(-(t - spT) / 180); spT = t;
    spNow += (spTarget - spNow) * k;
    if (Math.abs(spTarget - spNow) < 0.0005) spNow = spTarget;
    story.style.setProperty('--sp', spNow.toFixed(4));
    if (spNow !== spTarget) requestAnimationFrame(glide); else gliding = false;
  }
  function frame() {
    ticking = false;
    const y = scrollY;
    root.classList.toggle('hdx-hide', y > last && y > 240); last = y;
    const r = story.getBoundingClientRect();
    spTarget = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - innerHeight)));
    if (!gliding) { gliding = true; spT = performance.now(); requestAnimationFrame(glide); }
    let on = 0, bestD = Infinity;
    arts.forEach((a, k) => { const b = a.getBoundingClientRect(); const d = Math.abs(b.top + b.height / 2 - innerHeight / 2); if (d < bestD) { bestD = d; on = k; } });
    arts.forEach((a, k) => a.classList.toggle('on', k === on));
    story.dataset.ch = String(on);
  }
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
  addEventListener('resize', frame); frame();

  // favourites + recently viewed
  const fb = $('#favBtn');
  fb.classList.toggle('on', window.LLfav.has(handle));
  fb.addEventListener('click', () => fb.classList.toggle('on', window.LLfav.toggle(handle)));
  store.set('ll_recent', [handle, ...store.get('ll_recent', []).filter((x) => x !== handle && typeof x === 'string')].slice(0, 8));

  // "More about this bottle" pill: 3s after load, only if they have not scrolled yet; gone for good once they scroll
  const pill = $('#pkMorePill');
  if (pill) {
    let done = false;
    const hide = () => { if (scrollY < 120) return; done = true; pill.classList.remove('in'); setTimeout(() => { pill.hidden = true; }, 600); removeEventListener('scroll', hide); };
    addEventListener('scroll', hide, { passive: true });
    setTimeout(() => { if (done || scrollY >= 120) return; pill.hidden = false; requestAnimationFrame(() => requestAnimationFrame(() => pill.classList.add('in'))); }, 3000);
    pill.addEventListener('click', (e) => { e.preventDefault(); $('#story').scrollIntoView({ behavior: 'smooth' }); });
  }
})();
